import React, { useState } from "react";
import { getCourse } from "../../faunadb/queries/course";
import { getAllStudents } from "../../faunadb/queries/student";
import DashboardCard from "../../components/card/DashboardCard";
import ClassList from "./components/ClassList";
import StudentList from "../student/components/StudentList";
import InfoTable from "../../components/table/InfoTable";
import { useForm, Controller } from "react-hook-form";
import { Form, InputField, Label, SelectStyle } from "../../styles/common/Form";
import { useFaunaContext } from "../../providers/FaunaProvider";

import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { printErrorMessageFromFQL } from "../../faunadb/helpers/utils";
import Logging from "../logging/Loggings";
import {useQuery as useReactQuery, useMutation as useReactMutation, useQueryClient} from 'react-query';


const Course = (props) => {
  const courseId = props.match.params.id;
  const { handleSubmit, control } = useForm();
  const { handleSubmit: handleSubmit2, control: control2 , watch: watch2 } = useForm();
  const { queries, client } = useFaunaContext();
  const queryClient = useQueryClient();
  const {data, loading} = useReactQuery(['course',courseId], async()=> await getCourse(client, courseId));

  const {data: allStudents, loading: allStudentsLoading} = useReactQuery('allStudents', async()=> await getAllStudents(client, 9999));
  
  const [customQuota, setCustomQuota] = useState(data?.quota ?? 0);
  const onSubmit = (data) => {
    console.log(data);
    queries.course
      .ADD_USER_TO_COURSE(client, data.student.value, courseId)
      .then((response) => {
        if (response.errors) {
          printErrorMessageFromFQL(response.errors);
        } else {
          toast.success("Student Added");
          queries.log.logging(
            client,
            "Student",
            data.student.value,
            "Course",
            courseId,
            `join by admin`
          );
          queryClient.invalidateQueries(['course',courseId]);
        }
      });
  };

  const onChangeQuotaSubmit = (data) => {
    queries.course
      .CHANGE_COURSE_QUOTA(client, courseId, customQuota)
      .then((response) => {
        if (response.errors) {
          printErrorMessageFromFQL(response.errors);
        } else {
          toast.success("Quota Changed");
          queries.log.logging(
            client,
            "Course",
            courseId,
            "Course",
            courseId,
            `change quota to ${customQuota} by admin`
          );
          queryClient.invalidateQueries(['course',courseId]);
        }
      });
  }

  if (!data || !allStudents?.data) return <></>;
  const { classes, name, students } = data;
  const studentsOption = [];
  if (allStudents.data) {
    allStudents.data.map((student) =>
      studentsOption.push({
        label: `${student.email} ${student.phone_number} ${student.name}`,
        value: student._id,
      })
    );
  }

  return (
    <>
      {!loading && (
        <>
          <DashboardCard title={`${name}`}>
            <InfoTable
              cols={[
                { Headers: "Teacher", accessor: "teacher.name" },
                { Headers: "Price", accessor: "price" },
                { Headers: "Quota", accessor: "quota" },
                { Headers: "Weekday", accessor: "weekday" },
              ]}
              data={[data]}
            />
          </DashboardCard>
          {/* add number input field and submit button to change quota */}
          <DashboardCard title="改 Quota">
            <Form>
              <div className="row">
                <Label>Quota</Label>
                <InputField
                  type="number"
                  name="quota"
                  control={control2}
                  defaultValue={data.quota}
                  onChange={(e) => setCustomQuota(e.target.value)}
                />
                <InputField type="button" onClick={onChangeQuotaSubmit}/>
              </div>
              </Form>
          </DashboardCard>

          <DashboardCard title="Classes">
            <ClassList classes={classes.data} />
          </DashboardCard>
          <DashboardCard title="Students">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <Label>Add Student</Label>
                <Controller
                  as={<ReactSelect styles={SelectStyle} />}
                  options={studentsOption}
                  name="student"
                  isClearable
                  control={control}
                  defaultValue=""
                />
                {!allStudentsLoading && <InputField type="submit" />}
              </div>
            </Form>
            <StudentList
              students={students.data}
              courseId={courseId}
              updateGetCourseCache={()=>queryClient.invalidateQueries(['course',courseId])}
            />
          </DashboardCard>
          <DashboardCard title="Logging">
            <Logging type="Course" id={courseId} />
          </DashboardCard>
        </>
      )}
    </>
  );
};

export default Course;
